import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'marker-icon',
  templateUrl: './marker-icon.component.html',
  styleUrls: ['./marker-icon.component.scss']
})
export class MarkerIconComponent implements OnInit {
  @Input() icon: string;
  @Input() farbe: string;
  @Input() farbeRahmen: string;

  constructor() { }

  ngOnInit(): void {
  }

}
